import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[diIntegerOnly]'
})
export class IntegerOnlyDirective implements AfterViewInit {
  private inputElement: HTMLInputElement | null = null;
  private regex: RegExp = /^[0-9]*$/;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    // Cherche un <input> dans le composant custom (lua-input)
    this.inputElement = this.el.nativeElement.querySelector('input');
    if (!this.inputElement) {
      console.warn('Aucun <input> trouvé dans le composant personnalisé.');
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.inputElement || event.target !== this.inputElement) return;

    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

    if (allowedKeys.includes(event.key)) return;

    if (!this.regex.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (!this.inputElement || event.target !== this.inputElement) return;

    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    if (!this.regex.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
